import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CaseListItem } from '@packages/global';

interface VideoModalProps {
  caseItem: CaseListItem;
  onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ caseItem, onClose }) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-dark-950/90 backdrop-blur-sm" />

      {/* Modal content */}
      <div
        className="relative w-full max-w-4xl rounded-2xl overflow-hidden bg-dark-900 border border-dark-700 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-dark-700">
          <div>
            <h3 className="text-lg font-semibold text-white">{caseItem.title}</h3>
            <p className="text-sm text-dark-400 mt-0.5">{caseItem.desc}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-dark-400 hover:text-white hover:bg-dark-700 transition-colors cursor-pointer"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Video */}
        <div className="aspect-video bg-black">
          {caseItem.videoUrl ? (
            <video
              key={caseItem.videoUrl}
              src={caseItem.videoUrl}
              controls
              autoPlay
              className="w-full h-full"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center gap-3 text-dark-500">
              <i data-lucide="video-off" className="text-5xl" />
              <span className="text-sm">No video available</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
